import { Badge } from '@/components/ui/badge';
import type { GuildLevel } from '@/lib/api';

interface GuildLevelBadgeProps {
  level: GuildLevel;
}

const levelConfig: Record<
  GuildLevel,
  {
    label: string;
    className: string;
  }
> = {
  bronze: { label: 'Bronze', className: 'bg-amber-700 text-white hover:bg-amber-700' },
  iron: { label: 'Iron', className: 'bg-gray-500 text-white hover:bg-gray-500' },
  silver: { label: 'Silver', className: 'bg-slate-300 text-slate-900 hover:bg-slate-300' },
  gold: { label: 'Gold', className: 'bg-yellow-400 text-yellow-900 hover:bg-yellow-400' },
  diamond: { label: 'Diamond', className: 'bg-cyan-400 text-cyan-900 hover:bg-cyan-400' },
};

const fallbackConfig = { label: 'Unknown', className: '' };

export function GuildLevelBadge({ level }: GuildLevelBadgeProps) {
  const config = levelConfig[level] ?? fallbackConfig;
  return <Badge className={`text-xs ${config.className}`}>{config.label}</Badge>;
}
